import { getGuestCart, getGuestWishlist, saveGuestCart, saveGuestWishlist } from "../utils/guestStorage.js";

export const syncGuestDataToServer = async (userId) => {
  // ================= CART SYNC =================
  const guestCart = getGuestCart();

  for (const item of guestCart) {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("product_id", item.product_id);
    formData.append("cart_qty", item.cart_qty);
    formData.append("size", item.size || "");
    formData.append("color", item.color || "");
    formData.append("current_price", item.price);

    try {
      await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_cart",
        {
          method: "POST",
          body: formData,
        }
      );
    } catch (err) {
      console.error("Cart sync error:", err);
    }
  }

  // Clear guest cart after sync
  saveGuestCart([]);

  // ================= WISHLIST SYNC =================
  const guestWishlist = getGuestWishlist();

  for (const item of guestWishlist) {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("product_id", item.product_id);

    try {
      await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_wish",
        {
          method: "POST",
          body: formData,
        }
      );
    } catch (err) {
      console.error("Wishlist sync error:", err);
    }
  }

  // Clear guest wishlist after sync
  saveGuestWishlist([]);
};
